<template>
  <div class="report-table-content">
    <!-- <div class="report-callback">
      <div @click="callback">
        <svg class="icon" aria-hidden="true">
          <use xlink:href="#icon-fanhui1" />
        </svg>
        返回报表
      </div>
    </div> -->
    <div class="report-table-content-left">
      <div class="report-table-content-header">
        球台：￥{{tableAllAmount}} / {{tableAllNumber}}单
      </div>
      <div class="report-table-content-table">
        <div @click="activeClass(1)" :class="isActive == 1 ? 'active-color' : ''">分类</div>
        <div @click="activeClass(2)" :class="isActive == 2 ? 'active-color' : ''">模式</div>
        <div @click="activeClass(3)" :class="isActive == 3 ? 'active-color' : ''">结账</div>
      </div>
      <ul class="report-table-content-body" v-if="isActive == 1">
        <li v-for="(item,index) in tableClass" :key="index">
          <div>
            {{item.name}}：￥{{item.amount.toFixed(2)}}
            <span>{{item.number}}单</span>
          </div>
          <div class="body-bg" :style="'width:'+ item.bg_color+ '%' +';'"></div>
        </li>
      </ul>
      <ul class="report-table-content-body" v-if="isActive == 2">
        <li v-for="(item,index) in tableModel" :key="index" v-show="item.number > 0">
          <div>
            {{item.name}}：￥{{item.amount.toFixed(2)}}
            <span>{{item.number}}单</span>
          </div>
          <div class="body-bg" :style="'width:'+ item.bg_color + '%' + ';'"></div>
        </li>
      </ul>
      <ul class="report-table-content-body" v-if="isActive == 3">
        <li v-for="(item,index) in tableCheck" :key="index">
          <div>
            {{item.name}}：￥{{item.amount.toFixed(2)}}
            <span>{{item.number}}单</span>
          </div>
          <div class="body-bg" :style="'width:'+ item.bg_color + '%' +';'"></div>
        </li>
      </ul>
    </div>
    <div class="report-table-content-right">
      <!-- <div class="report-table-content-header">
        APP微信：￥123000.00 / 50单
      </div>
      <div class="report-table-content-table">
        <div>
          时间
          <p></p>
        </div>
        <div>
          用户
          <p></p>
        </div>
        <div>
          金额
          <p></p>
        </div>
      </div>
      <ul class="report-table-content-body">
        <el-scrollbar>
          <li>
            <div>20-06-19 17:35</div>
            <div>用户名称</div>
            <div>￥188.00</div>
          </li>
        </el-scrollbar>
      </ul> -->
    </div>
  </div>
</template>

<script>
import requstsMethod from "common/const";
import { response } from "network/response";
export default {
  props:['timeSlotValue'],
  data(){
    return{
      isActive: 1,
      tableClass: [],  //球桌分类
      tableModel: [],  //收费模式
      tableCheck: [],  //结账方式
    }
  },
  methods:{
    activeClass(e){
      this.isActive = e;
    },
    callback(){
      this.$emit("closeInfo")
    },
    initData(){
      if(this.timeSlotValue.length == 0){
        let todyDate = new Date;
        console.log(todyDate.getMonth(),'时间戳')
        let currentYear = todyDate.getFullYear(); //年
        let currentMonth = todyDate.getMonth() + 1 //月
        let currentDay = todyDate.getDate();  //日
      }
      //报表分类展示---分类
      response(requstsMethod.fun_Get_Api_Stock_Group_Type,{
        beginDate: this.timeSlotValue[0],
        endDate: this.timeSlotValue[1],
        queryType:"TYPE",
        totalBizTypeEnum:"TABLE"
      })
      .then(data => {
        console.log(data,'报表分类展示---分类')
        let allAmount = 0;
        data.forEach(item => allAmount += item.amount);
        data.forEach(item => item.bg_color = (item.amount / allAmount) * 100);
        this.tableClass = [...data];
      })
      //报表分类展示---模式
      response(requstsMethod.fun_Get_Api_Stock_Group_Type,{
        beginDate: this.timeSlotValue[0],
        endDate: this.timeSlotValue[1],
        queryType:"MODEL",
        totalBizTypeEnum:"TABLE"
      })
      .then(data => {
        console.log(data,'报表分类展示---模式')
        let allAmount = 0;
        data.forEach(item => allAmount += item.amount);
        data.forEach(item => item.bg_color = (item.amount / allAmount) * 100);
        this.tableModel = [...data];
      })
      //报表分类展示---结账方式
      response(requstsMethod.fun_Get_Api_Stock_Group_Type,{
        beginDate: this.timeSlotValue[0],
        endDate: this.timeSlotValue[1],
        queryType:"CHANNEL",
        totalBizTypeEnum:"TABLE"
      })
      .then(data => {
        console.log(data,'报表分类展示---结账方式')
        let allAmount = 0;
        data.forEach(item => allAmount += item.amount);
        data.forEach(item => item.bg_color = (item.amount / allAmount) * 100);
        this.tableCheck = [...data];
      })
    }
  },
  computed:{
    //球桌总收入
    tableAllAmount(){
      let amount = 0;
      this.tableClass.forEach(item => amount += item.amount);
      return amount.toFixed(2);
    },
    //球桌总单数
    tableAllNumber(){
      let number = 0;
      this.tableClass.forEach(item => number += item.number);
      return number;
    }
  },
  watch:{
    timeSlotValue(val,oldVal){
      this.initData()
    }
  },
  created(){
    console.log(this.timeSlotValue,'组件初始化拿到的日期')
    this.initData()
  }
}
</script>

<style lang="scss" scoped>
.report-table-content{
  height: 100%;
  font-family: Alibaba PuHuiTi, Alibaba PuHuiTi-Heavy;
  font-weight: 800;
  text-align: center;
  color: #ffffff;
  // .report-callback{
  //   height: 50px;
  //   margin-bottom: 8px;
  //   background: #3E3E3E;
  //   box-shadow: 0px 0px 5px #000;
  //   overflow: hidden;
  //   >div{
  //     margin: 10px 0 0 20px;
  //     line-height: 30px;
  //     height: 30px;
  //     width: 100px;
  //     background: #FF8B3E;
  //     box-shadow: 0px 0px 5px #000;
  //     border-radius: 2px;
  //     cursor: pointer;
  //   }
  // }
  .report-table-content-left{
    width: 43.9560%;
    // height: calc(100% - 58px);
    height: 100%;
    float: left;
    box-shadow: 0px 0px 5px #000;
    background: #3E3E3E;
    border-radius: 2px;
    .report-table-content-header{
      height: 80px;
      line-height: 80px;
      font-size: 20px;
      margin: 8px;
      background: #D97D11;
      box-shadow: 0px 0px 5px #000;
      border-radius: 2px;
    }
    .report-table-content-table{
      margin: 0 8px 8px;
      display: flex;
      justify-content: space-between;
      >div{
        height: 40px;
        line-height: 40px;
        font-size: 18px;
        width: calc((100% - 16px) / 3);
        background: #834B0A;
        box-shadow: 0px 0px 5px #000;
        border-radius: 2px;
        cursor: pointer;
      }
      >div:hover{
        box-shadow: 0px 0px 10px #2AFEB2 inset;
        background: rgba(42,254,178,0.1);
      }
      .active-color{
        background: #D97D11;
      }
    }
    .report-table-content-body{
      margin: 0 8px;
      display: flex;
      justify-content: space-between;
      flex-direction: column;
      >li{
        position: relative;
        z-index: 0;
        list-style: none;
        height: 30px;
        line-height: 30px;
        box-shadow: 0px 0px 5px #000;
        border-radius: 2px;
        margin-bottom: 8px;
        text-align: left;
        border-radius: 2px;
        cursor: pointer;
        >div{
          padding: 0 8px;
          >span{
            float: right;
          }
        }
        .body-bg{
          padding: 0;
          background: #D97D11;
          position: absolute;
          border-radius: 2px;
          top: 0;
          left: 0;
          height: 30px;
          z-index: -1;
        }
      }
      >li:hover{
        >:nth-child(1){
          box-shadow: 0px 0px 10px #2AFEB2 inset;
          background: rgba(42,254,178,0.1);
        }
      }
    }
  }
  .report-table-content-right{
    width: 55.0439%;
    // height: calc(100% - 58px);
    height: 100%;
    float: right;
    box-shadow: 0px 0px 5px #000;
    background: #3E3E3E;
    border-radius: 2px;
    .report-table-content-header{
      height: 80px;
      line-height: 80px;
      background: #D97D11;
      margin: 8px;
      font-size: 20px;
      box-shadow: 0px 0px 5px #000;
      border-radius: 2px;
    }
    .report-table-content-table{
      margin: 0 8px;
      display: flex;
      justify-content: space-between;
      >div{
        position: relative;
        height: 40px;
        line-height: 40px;
        font-size: 18px;
        background: #834B0A;
        width: calc((100% - 16px) / 3);
        box-shadow: 0px 0px 5px #000;
        border-radius: 2px;
        cursor: pointer;
        >p{
          display: inline-block;
          border-top:10px solid rgba(255,255,255,1);
          border-right:10px solid rgba(255,255,255,0);
          border-bottom: 10px solid rgba(255,255,255,0);
          border-left:10px solid rgba(255,255,255,0);
          position: absolute;
          top: 18px;
          margin-left: 10px;
        }
      }
      >div:hover{
        background: rgba(42,254,178,0.1);
        box-shadow: 0px 0px 10px #2AFEB2 inset;
      }
    }
    .report-table-content-body{
      height: calc(100% - 144px);
      ::v-deep.el-scrollbar{
        height: 100%;
        .el-scrollbar__wrap{
          .el-scrollbar__view{
            padding: 8px 8px 0;
            >li{
              display: flex;
              justify-content: space-between;
              height: 30px;
              line-height: 30px;
              font-size: 14px;
              margin-bottom: 8px;
              background: #4D4D4D;
              border-radius: 2px;
              box-shadow: 0px 0px 5px #000;
              >div{
                width: calc((100% - 16px) / 3);
              }
            }
            >li:hover{
              background: rgba(42,254,178,0.1);
              box-shadow: 0px 0px 10px #2AFEB2 inset;
            }
          }
        }
      }
    }
  }
}
</style>